import { render, staticRenderFns } from "./BemTerceiroForm.vue?vue&type=template&id=e29f0c48"
import script from "./BemTerceiroForm.vue?vue&type=script&lang=js"
export * from "./BemTerceiroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports